import { requestGet } from '@/common/request';

export interface queryInventoryRuleParams {
  inventoryId?: string;
  historyId?: string;
}

export interface queryInventoryRuleRes {
  ret: string;
  msg: string;
  data: {
    list:
      | Array<{
          subStrategyId: string;
          subStrategyName: string;
          rules: Array<{ ruleId: string; ruleName: string; ruleDetails: Array<string> | [] }> | [];
        }>
      | [];
  };
}

//品类盘货 - 查询盘货的规则
export async function queryInventoryRule(params: queryInventoryRuleParams): Promise<queryInventoryRuleRes> {
  return await requestGet('/goodsPool/queryInventoryRule', params);
}
